if (!customElements.get('bf-pdp-coupons')) {
  customElements.define('bf-pdp-coupons', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.timers = new Map();
      const options = { signal: this.controller.signal };
      const toggle = this.querySelector('.bf-pdp-coupons__toggle');
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('span').textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
        this.querySelectorAll('[data-extra-coupon]').forEach(row => { row.hidden = !expanded; });
      }, options);
      this.querySelectorAll('[data-code]').forEach(button => {
        button.addEventListener('click', async () => {
          if (button.dataset.copying === 'true') return;
          clearTimeout(this.timers.get(button));
          button.dataset.copying = 'true';
          let copied = false;
          try {
            if (navigator.clipboard?.writeText && window.isSecureContext) {
              try { await navigator.clipboard.writeText(button.dataset.code); copied = true; } catch {}
            }
            if (!copied) {
              const input = document.createElement('textarea');
              input.value = button.dataset.code;
              input.readOnly = true;
              input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
              document.body.append(input);
              try { input.select(); copied = document.execCommand('copy'); } finally { input.remove(); button.focus({ preventScroll: true }); }
            }
          } catch { copied = false; }
          finally { delete button.dataset.copying; }
          if (!this.isConnected) return;
          const label = copied ? this.dataset.copiedLabel : this.dataset.errorLabel;
          button.textContent = label;
          this.querySelector('.bf-pdp-coupons__status').textContent = copied ? `${button.dataset.code} ${label}` : label;
          this.timers.set(button, setTimeout(() => {
            button.textContent = this.dataset.copyLabel;
            this.timers.delete(button);
          }, 1800));
        }, options);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.timers?.forEach(timer => clearTimeout(timer));
      this.timers?.clear();
    }
  });
}
